import { render } from "./formProcess.vue?vue&type=template&id=1382202a&scoped=true"
import script from "./formProcess.vue?vue&type=script&lang=js"
export * from "./formProcess.vue?vue&type=script&lang=js"

import "./formProcess.vue?vue&type=style&index=0&id=1382202a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1382202a"]])

export default __exports__